import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
let lang = window.location.search.includes('hl=en') ? 'en' : 'fa';

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'en',
  load: 'languageOnly',
  lng: lang,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  // language resources
  resources: {
    en: {
      translation: {
        welcome: 'Welcome to React Azadi',
        Error_401: 'access denied, please log out and login again   ',
      },
    },
    fa: {
      translation: {
        welcome: 'Chào mừng đến với bình nguyên vô tận',
        Error_401: 'کاربر گرامی دسترسی به آیتم مورد نظر مجاز نیست، لطفا از سیستم خارج و دوباره وارد سیستم شوید',
      },
    },
  },
});

export default i18n;
